import { provideAnimations } from '@angular/platform-browser/animations'
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
  LOCALE_ID,
} from '@angular/core'
import { provideRouter } from '@angular/router'
import { registerLocaleData } from '@angular/common'
import localeFr from '@angular/common/locales/fr'

import { routes } from './app.routes'
import { provideStore } from '@ngxs/store'
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin'
import { AuthState } from './core/stores/auth/auth.state'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { tokenInterceptor } from './core/interceptors/token.interceptor'
import { errorInterceptor } from './core/interceptors/error.interceptor'
import { MessageService } from 'primeng/api'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { providePrimeNG } from 'primeng/config'
import Aura from '@primeng/themes/aura'
import { HttpClient, HttpClientModule } from '@angular/common/http'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { HttpLoaderFactory } from './core/i18n/http-loader.factory'

// Register French locale data
registerLocaleData(localeFr, 'fr-FR')

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([tokenInterceptor, errorInterceptor])),
    provideStore(
      [AuthState],
      withNgxsStoragePlugin({
        keys: ['auth.token'],
      })
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
    }),
    importProvidersFrom(
      HttpClientModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        defaultLanguage: 'fr',
      })
    ),
    MessageService,
  ],
}
